import { ElementRef } from '@angular/core';
import { placementToAlign } from './placement-to-alignment';

export function applyTitleSettings(
  data: any,
  titleEl: ElementRef<HTMLElement>
): void {
  const titleStyleSettingsComposition = (data && data.titleStyleSettingsComposition) || {};

  const {
    titleFontWeight,
    titleSize,
    titleColor,
    titlePlacement
  } = titleStyleSettingsComposition;

  const fontWeight = titleFontWeight && titleFontWeight.value;
  const fontSize = titleSize && titleSize.value;
  const color = titleColor && titleColor.value;
  const placement = titlePlacement && titlePlacement.value;

  const titleAlignment = placementToAlign(placement);

  if (titleEl && titleEl.nativeElement) {
    if (fontWeight) {
      titleEl.nativeElement.style.setProperty('--title-settings-font-weight', fontWeight);
    }
    if (fontSize) {
      titleEl.nativeElement.style.setProperty('--title-settings-font-size', fontSize + 'px');
    }
    if (color) {
      titleEl.nativeElement.style.setProperty('--title-settings-color', color);
    }
    if (placement) {
      titleEl.nativeElement.style.setProperty('--title-settings-align', titleAlignment);
    }
  }
}

export function applySubtitleSettings(
  data: any,
  subtitleEl: ElementRef<HTMLElement>
): void {
  const SubtitleStyleSettingsComposition = (data && data.subtitleStyleSettingsComposition) || {};

  const {
    subtitleFontWeight,
    subtitleSize,
    subtitleColor,
    subtitlePlacement
  } = SubtitleStyleSettingsComposition;

  const fontWeight = subtitleFontWeight && subtitleFontWeight.value;
  const fontSize = subtitleSize && subtitleSize.value;
  const color = subtitleColor && subtitleColor.value;
  const placement = subtitlePlacement && subtitlePlacement.value;

  const subtitleAlignment = placementToAlign(placement);

  if (subtitleEl && subtitleEl.nativeElement) {
    if (fontWeight) {
      subtitleEl.nativeElement.style.setProperty('--subtitle-settings-font-weight', fontWeight);
    }
    if (fontSize) {
      subtitleEl.nativeElement.style.setProperty('--subtitle-settings-font-size', fontSize + 'px');
    }
    if (color) {
      subtitleEl.nativeElement.style.setProperty('--subtitle-settings-color', color);
    }
    if (placement) {
      subtitleEl.nativeElement.style.setProperty('--subtitle-settings-align', subtitleAlignment);
    }
  }
}



